<template>
  <div class="card">
    <el-form :model="frm" :rules="rules" status-icon ref="frm" label-width="120px" class="join-form" label-position="top" >
      <div class="card-body gray">
        <h5>회원 가입 요청</h5>
        <p class="small description">기본정보를 입력해 주세요.</p>
        <hr />
        <div class="card-form-user">
          <el-form-item label="이름" prop="name">
            <el-input v-model.trim="frm.name" placeholder="본인 실명으로 가입하시기 바랍니다" maxlength="5"></el-input>
          </el-form-item>
          <el-form-item label="생년월일" required>
            <el-col :span="8">
              <el-form-item prop="birthday_yyyy">
                <el-select v-model="frm.birthday_yyyy" placeholder="년" >
                  <el-option v-for="y in yearCount" :key="y" :label="`${y + startYear} 년`" :value="y + startYear">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="birthday_mm">
                <el-select v-model="frm.birthday_mm" placeholder="월">
                  <el-option v-for="m in 12" :key="m" :label="`${m} 월`" :value="getDateValue(m)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="birthday_dd">
                <el-select v-model="frm.birthday_dd" placeholder="일">
                  <el-option v-for="d in getDays" :key="d" :label="`${d} 일`" :value="getDateValue(d)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="핸드폰번호" prop="phone">
            <el-input type="tel" :disabled="phoneDisabled" v-model.trim="frm.phone" placeholder="'-' 를 빼고 입력해주세요" @change="autoHypenPhone('phone')" maxlength="13" class="el-input-phone"></el-input>
            <el-button type="primary" v-if="!phoneDisabled" @click="requestCallback">인증요청</el-button>
          </el-form-item>
          <el-form-item label="인증번호" v-if="!isDisabled">
            <el-input v-model.trim="pincode" :disabled="isDisabled" type="tel" maxlength="6" placeholder="인증번호(6자리)" class="el-input-pincode"></el-input>
            <el-button type="danger" :disabled="isDisabled || pincode.length !== 6" @click="confirmCallback">인증 확인</el-button>
            <el-button type="primary" :disabled="phoneDisabled" @click="requestCallback">재요청</el-button>
            <br />
            <countdown ref="countdown" v-if="!isDisabled" :time="timer" :auto-start="false">
              <template slot-scope="props">남은 시간 {{`${props.minutes} : ${props.seconds}`}}</template>
            </countdown>
          </el-form-item>
          <el-form-item label="클래스" prop="class_seq">
            <el-select v-model="frm.class_seq" placeholder="클래스를 선택해주세요" style="width: 100%;">
              <el-option v-for="item in classData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="학교" prop="school_name">
            <el-input v-model.trim="frm.school_name" maxlength="30" placeholder="최종 학교를 입력해주세요 (선택사항)"></el-input>
          </el-form-item>
          <el-form-item label="알림 유형" prop="msg_type">
            <el-radio-group v-model="frm.msg_type" class="stone-radio-btton">
              <el-radio-button label="K">카카오톡</el-radio-button>
              <el-radio-button label="S">SMS</el-radio-button>
              <el-radio-button label="N">수신거부</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>

      <div class="card-body text-right">
        <el-button @click="previous">이전</el-button>
        <el-button type="primary" :disabled="!otp.confirm" @click="submitForm('frm')">가입 요청</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>

import common from '@/modules/common'
import VueCountdown from '@xkeshi/vue-countdown'

export default {
  name: 'JOIN',
  mixins: [common.mixins],
  components: {countdown: VueCountdown},
  data () {
    return {
      frm: {
        name: '',
        phone: '',
        school_name: '',
        birthday: '',
        birthday_yyyy: '',
        birthday_mm: '',
        birthday_dd: '',
        class_seq: '',
        msg_type: 'K'
      },
      yearCount: 0,
      startYear: 1965 - 1,
      classData: [],
      rules: {
        name: [
          { required: true, message: '사용자 이름을 입력하십시오.', trigger: 'blur' },
          { min: 2, max: 5, message: '최소 2자 이상 최대 5자까지 입력하십시오.' },
          { type: 'string', pattern: /^[가-힣]{2,5}$/, message: '본인 실명으로 가입하십시오.' }
        ],
        phone: [
          { required: true, message: '핸드폰번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { type: 'string', pattern: /^01([0|1|6|7|8|9]?)-?(\d{3,4})-?(\d{4})$/, message: '핸드폰번호 형식에 맞지 않습니다.' }
        ],
        birthday_yyyy: [
          { required: true, message: '생년월일(년도)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_mm: [
          { required: true, message: '생년월일(월)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_dd: [
          { required: true, message: '생년월일(일)을 입력하십시오.', trigger: 'change' }
        ],
        school_name: [
          { min: 2, max: 20, message: '최소 2자 이상 최대 20자까지 입력하십시오.' }
        ],
        class_seq: [
          { required: true, message: '클래스를 선택하십시오.', trigger: 'change' }
        ],
        msg_type: [
          { required: true, message: '알림 유형을 선택하십시오.', trigger: 'change' }
        ]
      },
      isDisabled: true,
      phoneDisabled: false,
      timer: 3 * 60 * 1000,
      pincode: '',
      otp: {
        user_otp_seq: 0,
        cmid: '',
        confirm: false,
        phone: ''
      }
    }
  },
  created () {
    common.axios.post('/class/list/reg')
      .then(response => {
        const result = response.data
        result.forEach(c => {
          this.classData.push({label: c.class_name, value: c.class_seq})
        })
      })
  },
  computed: {
    getDays: {
      get: function () {
        return this.frm.birthday_mm !== '' ? this.getMonthLastDay(this.frm.birthday_yyyy + this.frm.birthday_mm) : 31
      }
    }
  },
  mounted () {
    const today = new Date()
    this.yearCount = (this.startYear - today.getFullYear()) * -1
  },
  methods: {
    previous () {
      this.$router.push({name: 'AGREEMENT'})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.otp.confirm) {
            this.$message.error('인증확인이 필요합니다.')
            return
          }
          if (!this.otp.phone || this.otp.phone !== this.getOnlyNumber(this.frm.phone)) {
            this.$message.error('전화번호가 변경되어 재인증이 필요합니다.')
            this.otp = {user_otp_seq: 0, cmid: '', confirm: false, phone: ''}
            this.phoneDisabled = false
            return
          }
          this.frm.birthday = this.frm.birthday_yyyy + this.frm.birthday_mm + this.frm.birthday_dd
          this.frm.phone = this.getOnlyNumber(this.frm.phone)
          common.axios.post('/user/join', this.frm)
            .then(response => {
              if (response.data.status === 1) {
                // const successMsg = '가입 요청이 완료되었습니다.<br /><strong>관리자 승인 후 로그인이 가능합니다.</strong>'
                const successMsg = '가입 요청이 완료되었습니다.'
                this.$alert(successMsg, '', {
                  dangerouslyUseHTMLString: true,
                  showClose: false,
                  callback: action => {
                    this.$router.push({name: 'LOGIN_S'})
                  }
                })
              } else {
                this.$message.error(response.data.message)
                this.otp = {user_otp_seq: 0, cmid: '', confirm: false, phone: ''}
                this.phoneDisabled = false
              }
            })
            .catch(error => {
              if (error.response.data.errors) {
                error.response.data.errors.map(msg => {
                  this.$message.error(msg)
                })
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    getDateValue (value) {
      return (value < 10 ? '0' : '') + value
    },
    autoHypenPhone (elem) {
      const value = this.getOnlyNumber(this.frm[elem])
      let tmp = ''
      if (value.length < 4) {
        tmp = value
      } else if (value.length < 7) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3)
      } else if (value.length < 11) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 3)
        tmp += '-'
        tmp += value.substr(6)
      } else {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 4)
        tmp += '-'
        tmp += value.substr(7)
      }
      this.frm[elem] = tmp
    },
    requestCallback () {
      if (!this.frm.phone) {
        this.$alert('전화번호를 입력하십시오.')
        return
      }
      this.otp = {user_otp_seq: 0, cmid: '', confirm: false, phone: ''}
      common.axios.post('/kakao/otp/request', {phone: this.getOnlyNumber(this.frm.phone)})
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          if (result.result_code === '200') {
            this.$alert('인증번호가 발송되었습니다. 3분이내에 인증번호를 입력하십시오.')
            this.otp.user_otp_seq = result.user_otp_seq
            this.otp.cmid = result.cmid
            this.isDisabled = false
            this.$nextTick(() => {
              const countdown = this.$refs.countdown
              // 카운트를 하고 있으면 정지한다.
              if (countdown.counting) {
                countdown.stop()
              }
              // 카운트 초기화
              countdown.count = this.timer
              // 카운팅 시작
              countdown.start()
            })
          } else {
            this.$alert('인증번호 발송 오류입니다. 관리자에게 문의하십시오.')
          }
        })
    },
    confirmCallback () {
      if (!this.pincode) {
        this.$alert('인증번호를 입력하십시오.')
        return
      }
      const param = Object.assign({otp_no: this.pincode}, this.otp)
      common.axios.post('/kakao/otp/confirm', param)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          if (result.result_code === '200') {
            this.$alert('인증되었습니다.')
            this.initPincode(true)
            this.otp.confirm = true
            this.otp.phone = result.phone
          } else if (result.result_code === '600') {
            this.$alert('일치하지 않는 인증번호입니다.')
          } else if (result.result_code === '700') {
            this.$alert('인증시간이 만료되었습니다. 인증번호를 다시 요청하십시오.')
            this.initPincode(false)
          } else {
            this.$alert(result.result_code)
          }
        })
    },
    initPincode (isSuccess) {
      this.isDisabled = true
      this.timer = 0
      this.pincode = ''
      this.phoneDisabled = isSuccess
    }
  }
}
</script>

<style scoped>
  .el-input-phone {
    width: calc(100% - 105px);
  }
  .el-input-pincode {
    width: 206px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Join.vue